<div class="loader-backdrop" *ngIf="backdrop"></div>

<div class="loader-icon">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
